import React from "react";
import { Link } from "react-router-dom";

export default function PlaceHotelsAccordion(props) {
  return (
    <div className="accordion-item search-for-places-list-item p-0">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed text-capitalize"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${props.title.split(" ").slice(0,1).join("").toLowerCase()}`}
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          {props.title}
        </button>
      </h2>
      <div
        id={props.title.split(" ").slice(0,1).join("").toLowerCase()}
        className="accordion-collapse collapse"
        data-bs-parent="#searchPlacesAccordion"
      >
        <div className="accordion-body">
          <ul className="p-0">
            {props.hotelsArray.map((hotel, index) => {
              return (
                <li className="text-capitalize" key={index}>
                  <Link to={`/hotel/${hotel._id}`}>{hotel.hotel_name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
